/* v5.7 : recherche repliable sur mobile et galerie photo à faire glisser (fiche produit). */
(function(){"use strict";
  var b=document.body,t=document.getElementById("searchToggle");
  if(t)t.addEventListener("click",function(){var o=b.classList.toggle("search-open");t.setAttribute("aria-expanded",o);if(o){var i=document.getElementById("searchInput");i&&i.focus();}});
  Array.prototype.forEach.call(document.querySelectorAll("[data-mgal]"),function(g){
    var tr=g.querySelector(".m-gal__track"),c=g.querySelector("[data-mgal-count]"),n=tr.children.length;
    var upd=function(){if(c)c.textContent=(Math.round(tr.scrollLeft/(tr.clientWidth||1))+1)+" / "+n;};
    tr.addEventListener("scroll",upd,{passive:true});upd();
    var root=g.closest("[data-product-handle]");if(!root)return;
    var vs=[];try{vs=JSON.parse(root.querySelector("script[data-variants]").textContent)}catch(e){}
    /* Choix d'une variante : la galerie saute à sa photo (défilement direct, le défilement « smooth » est ignoré avec le scroll-snap). */
    root.addEventListener("change",function(e){
      if(!e.target.matches("[data-option]"))return;
      setTimeout(function(){
        var f=root.querySelector("[data-variant-id]"),id=f&&f.value,v=null;
        for(var k=0;k<vs.length;k++){if(String(vs[k].id)===String(id)){v=vs[k];break;}}
        if(!v||!v.featured_image)return;
        var s=tr.querySelector('[data-media="'+v.featured_image.id+'"]');
        if(s){tr.scrollLeft=s.offsetLeft;upd();}
      },60);
    });
  });
})();
